import type { RootLocationFeatureToggles } from '@cognite/apm-config';

const OBSERVATION_WRITE_BACK_FUNCTION_EXTERNAL_ID_PREFIX =
  'sap_writeback_odata-';

export const getWriteBackFunctionExternalId = (project: string) =>
  `${OBSERVATION_WRITE_BACK_FUNCTION_EXTERNAL_ID_PREFIX}${project}`;

// is SAP enabeled
export const checkIfSapWriteBackIsEnabled = (
  rootLocationFeatureToggles:
    | RootLocationFeatureToggles
    | Record<string, boolean>
    | undefined
): boolean =>
  Boolean(
    typeof rootLocationFeatureToggles?.observations === 'object' &&
      rootLocationFeatureToggles?.observations?.isWriteBackEnabled
  );
